import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import { connectProps } from 'store';
import { updateLang, langProp, userIDProp } from 'model/component-props';

import _ from 'lodash';

import content from './content';
import HomeCard from '../homecard/HomeCard';
import './home.css';
import storehouse from 'icons/storehouse.png';
import debt from 'icons/debt.png';
import silk from 'icons/silk.png';

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center'
    }
};

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: true
        };

        this.linkItems = this.linkItems.bind(this);
        this.linkCustomers = this.linkCustomers.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount(){
        let id = this.props.userIDProp;
        if (_.isEmpty(id)) {
          id = window.sessionStorage.getItem('userID');
        }
        if (_.isEmpty(id)) {
          return this.props.history.push('/login');
        }
    }

    linkItems = () => {
        this.props.history.push('/items');
    }

    linkCustomers = () => {
        this.props.history.push('/customers');
    }

    handleClick = () => {
        this.setState({
            lang: !this.state.lang
        });

        if(this.state.lang === true){
            this.props.updateLang('EN');
        } else {
            this.props.updateLang('GR');
        }

    }

    onItemsCardClick = () => {
        this.linkItems();
    }

    onBalanceCardClick = () => {
        this.linkCustomers();
    }

    onCollectionsCardClick = () => {
        this.props.history.push('/collections');
    }

    render() {
        const { classes } = this.props;
        const { langProp } = this.props;
        return (
            <div className={classes.container}>
                <div
                  className="language-selector-container">
                    {this.state.lang ? <span style={{position: 'absolute', top: '1px', right: '66px'}}>GR</span> : <span style={{position: 'absolute', top: '1px', right: '66px'}}>EN</span>}
                    <label className="switch">
                        <input
                          onClick={this.handleClick}
                          type="checkbox"
                        />
                    <div></div>
                    </label>
                </div>
                <div style={{marginTop: '50px', display: 'flex', justifyContent: 'space-evenly'}}>
                <HomeCard title={content[langProp].cardA}
                  photo={storehouse}
                  className="storehouse-photo"
                  onClick={() => this.onItemsCardClick()}
                />
                <HomeCard title={content[langProp].cardB}
                  photo={debt}
                  className="balance-photo"
                  onClick={() => this.onBalanceCardClick()}
                />
                <HomeCard title={content[langProp].cardC}
                photo={silk}
                className="collections-photo"
                onClick={() => this.onCollectionsCardClick()}
              />
                </div>
            </div>
        );
    }
}

export default connectProps(updateLang, langProp, userIDProp)(withRouter(withStyles(styles)(Home)));



// WEBPACK FOOTER //
// ./src/components/home/Home.js